import { useTranslation } from 'react-i18next';
import { resources } from '../../../../resources/resources';

import { useNavigate } from 'react-router-dom';
import Breadcrumbs from '../../../../../../common/widgets/Breadcrumbs';
import applicationCrumbs from '../../../ApplicationCrumbs';
import PlatformInformation from '../../../Common/PlatformInformation';
import MyAccountMenu from '../../Common/MyAccountMenu';
import { AttendanceCheckIn } from './AttendanceCheckIn';

export const AttendanceCheckInPage = () => {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();

  const crumbs = applicationCrumbs(translate);

  return (
    <>
      <Breadcrumbs
        entries={[
          crumbs.home,
          crumbs.accountDashboard,
          crumbs.timeAndAttendance,
          crumbs.checkIn,
        ]}
      />
      <section className="section-main section-actions my-account-page">
        <div className="container">
          <div className="area-actions">
            <MyAccountMenu />
          </div>
          <div className="area-content">
            <PlatformInformation />
            <div className="panel panel-time-and-attendance panel-check-in padding-xl">
              <div className="btn-panel-back-wrapper">
                <button
                  className="btn btn-panel-back"
                  onClick={() => navigate('/my-account/time-and-attendance')}
                >
                  <span className="btn-text">
                    {translate(resources.menu.timeAndAttendance)}
                  </span>
                </button>
              </div>
              <h1>{translate(resources.menu.checkIn)}</h1>
              <AttendanceCheckIn />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
